module.exports = __webpack_public_path__ + "img/bulage-1.b0d9a62c.jpg";